import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stateFilter'
})

export class StateFilterPipe implements PipeTransform {

  // transform(states: Array<any>, query: any): Array<any> {
  //   return query === undefined ? states : states.filter((state: any) => state?.name.search(RegExp(query, 'i')) !== -1);
  // }

  transform(states: Array<any>, query: any): Array<any> {
    if (!states || !Array.isArray(states)) {
      return []; // Return an empty array if states is null, undefined, or not an array
    }
    if (!query) {
      return states; // If query is undefined or null, return the original states array
    }
    return states.filter((state: any) => state?.name.search(RegExp(query, 'i')) !== -1);
  }

}
